import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AdminLayout from '../components/AdminLayout';

const MENU_ITEMS = [
  {
    path: '/admin/users',
    title: 'Foydalanuvchilar',
    desc: "Ro'yxat, qidiruv, blok/unblok",
    icon: '👥',
  },
  {
    path: '/admin/moderation',
    title: 'Ustalar moderatsiyasi',
    desc: 'Pending ustalarni tasdiqlash yoki rad etish',
    icon: '🛡️',
  },
  {
    path: '/admin/service-categories',
    title: 'Xizmat kategoriyalari',
    desc: "Xizmat turlarini qo'shish va boshqarish",
    icon: '🗂️',
  },
  {
    path: '/admin/providers',
    title: "Xizmat ko'rsatuvchilar",
    desc: "Ko'rsatuvchilarni ro'yxatdan o'tkazish va boshqarish",
    icon: '🧰',
  },
  {
    path: '/admin/orders',
    title: 'Buyurtmalar monitoringi',
    desc: 'Real-time statistika va buyurtmalar',
    icon: '📦',
  },
  {
    path: '/admin/disputes',
    title: 'Disputlar',
    desc: 'Nizolarni ko\'rib chiqish va hal qilish',
    icon: '⚖️',
  },
  {
    path: '/admin/notifications',
    title: 'Push xabarlar',
    desc: 'Foydalanuvchilarga bildirishnoma yuborish',
    icon: '🔔',
  },
  {
    path: '/admin/commission',
    title: 'Komissiya',
    desc: 'Kategoriya bo\'yicha komissiya foizi',
    icon: '💰',
  },
  {
    path: '/admin/reports',
    title: 'Moliyaviy hisobot',
    desc: 'Kunlik / haftalik / oylik daromad',
    icon: '📊',
  },
];

export default function AdminDashboard() {
  const { auth } = useAuth();
  const navigate = useNavigate();

  const fullName = auth?.user
    ? [auth.user.firstName, auth.user.lastName].filter(Boolean).join(' ')
    : 'Admin';

  return (
    <AdminLayout>
      <h2 style={s.welcome}>Xush kelibsiz, {fullName}!</h2>
      <p style={s.desc}>Quyidagi bo'limlardan birini tanlang.</p>
      <div style={s.grid}>
        {MENU_ITEMS.map((item) => (
          <button key={item.path} style={s.card} onClick={() => navigate(item.path)}>
            <span style={s.cardIcon}>{item.icon}</span>
            <span style={s.cardTitle}>{item.title}</span>
            <span style={s.cardDesc}>{item.desc}</span>
          </button>
        ))}
      </div>
    </AdminLayout>
  );
}

const s = {
  welcome: {
    margin: '0 0 4px',
    fontSize: '22px',
    fontWeight: '700',
    color: 'var(--text)',
  },
  desc: {
    margin: '0 0 28px',
    fontSize: '14px',
    color: 'var(--text-muted)',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: '16px',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    padding: '24px',
    background: 'var(--surface)',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    cursor: 'pointer',
    textAlign: 'left',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  },
  cardIcon: {
    fontSize: '28px',
  },
  cardTitle: {
    fontSize: '15px',
    fontWeight: '700',
    color: 'var(--text)',
  },
  cardDesc: {
    fontSize: '13px',
    color: 'var(--text-muted)',
    lineHeight: '1.4',
  },
};
